<template>
  <pack-card-item />
</template>

<script>
import PackCardItem from './PackCardItem.vue'
export default {
  props:{
    packSelected: {
      type: Object
    }
  },

 
  components: { PackCardItem },
 
}
</script>

<style></style>